export const LIMIT = 100;
export const UPLOAD_CONST = '';
export const LOGO = process.env.REACT_APP_LOGO;
export const BANNER = process.env.REACT_APP_BANNER;

export const URI = process.env.REACT_APP_URI;
export const UPLOAD_URI = process.env.REACT_APP_URI;

export const ORDER_STATUS = [
  'PENDING',
  'PROCESSING',
  'ACCEPTED',
  'READY TO DISPATCH',
  'PICKED UP',
  'IN TRANSIT',
  'DELIVERED',
  'OUT FOR DELIVERY',
  'DELIVERED',
  'RTO',
  'RETURN REQUEST',
  'RETURN CANCELLED',
  'RETURN ACCEPTED',
  'RETURN COMPLETED',
  'INCORRECT',
  'REFUNDED',
  'CANCELLED',
  'FAILED',
  'RETURNED',
];

export const ORDER_STATUS_ENUM = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  ACCEPTED: 'ACCEPTED',
  READY_TO_DISPATCH: 'READY TO DISPATCH',
  PICKED_UP: 'PICKED UP',
  IN_TRANSIT: 'IN TRANSIT',
  DELIVERED: 'DELIVERED',
  OUT_FOR_DELIVERY: 'OUT FOR DELIVERY',
  DELIVERED: 'DELIVERED',
  RTO: 'RTO',
  RETURN_REQUEST: 'RETURN REQUEST',
  RETURN_CANCELLED: 'RETURN CANCELLED',
  RETURN_ACCEPTED: 'RETURN ACCEPTED',
  RETURN_COMPLETED: 'RETURN COMPLETED',
  INCORRECT: 'INCORRECT',
  REFUNDED: 'REFUNDED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  RETURNED: 'RETURNED',
};
